import { z } from "zod";

export type MessageContentAction = z.infer<typeof MessageContentActionSchema>;
export const MessageContentActionSchema = z.object({
  type: z.string(),
  id: z.string(),
  password: z.string(),
  target_conversation_id: z.string(),
});
